import invariant from 'invariant';

import { isPointGeotype } from './isPointGeotype';

export enum RadiusType {
  state = 'state',
  country = 'country',
}

export type RadiusString = string;
export type RadiusParam = RadiusString | null | undefined;

export const radiusStringToInt = (radius: RadiusParam) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (radius) {
    case '':
      return null;
    case 'country':
      return -1;
    case 'state':
      return -2;
    default:
      invariant(radius, 'Search radius is null or undefined');
      return parseInt(radius, 10);
  }
};

export const radiusIntToString = (
  radius: number | null | undefined,
  geoType: string | null | undefined,
): RadiusString | undefined => {
  if (!radius && isPointGeotype(geoType)) {
    return '';
  }

  if (radius === -1) {
    return 'country';
  }

  if (radius === -2) {
    return 'state';
  }

  return radius ? String(radius) : undefined;
};
